import { render, staticRenderFns } from "./AppIconButton.vue?vue&type=template&id=642c154e&scoped=true&"
import script from "./AppIconButton.vue?vue&type=script&lang=js&"
export * from "./AppIconButton.vue?vue&type=script&lang=js&"
import style0 from "./AppIconButton.vue?vue&type=style&index=0&id=642c154e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642c154e",
  null
  
)

export default component.exports